import { Injectable } from '@angular/core';
import { Observable, from, BehaviorSubject } from 'rxjs';
import { map } from 'rxjs/operators';
import firebase from 'firebase/app';
import { AngularFirestore } from '@angular/fire/firestore';

import { ChatBotMessage, ChatBotModel } from '../models';

@Injectable({
  providedIn: 'root',
})
export class ChatBotService {
  public selectedChatbot$: BehaviorSubject<ChatBotModel> = new BehaviorSubject(
    null
  );

  constructor(private afs: AngularFirestore) {}

  public createChatRoom(chatbotPayload: ChatBotModel): Observable<any> {
    return from(
      this.afs.collection('chatMessages').add({ ...chatbotPayload })
    ).pipe(
      map((action) => {
        action.update({
          id: action.id,
        });
        return action.id;
      })
    );
  }

  public async sendMessage(
    chatbotId: string,
    chatMessage: ChatBotMessage
  ): Promise<any> {
    const ref = this.afs.collection('chatMessages').doc(chatbotId);
    return ref.update({
      messages: firebase.firestore.FieldValue.arrayUnion({ ...chatMessage }),
    });
  }

  public getChatbot(userId: string): Observable<any> {
    return this.afs
      .collection('chatMessages', (ref) => ref.where('userId', '==', userId))
      .valueChanges()
      .pipe(map((actions) => actions[0]));
  }

  public getAllAdminUsers(): Observable<any> {
    return this.afs
      .collection('users', (ref) => ref.where('role', '==', 'ADMIN'))
      .valueChanges();
  }

  public getChatBotList(): Observable<any> {
    return this.afs
      .collection(`chatMessages`, (ref) => ref.orderBy('createdAt', 'desc'))
      .valueChanges();
  }

  public selectChatBot(chatbot: ChatBotModel): void {
    this.selectedChatbot$.next(chatbot);
  }

  public setChatSession(session: any): void {
    localStorage.setItem('_gcsession', session);
  }

  public getChatSession(): any {
    return localStorage.getItem('_gcsession');
  }

  public deleteSession(): void {
    localStorage.removeItem('_gcsession');
  }

  public removeChatBot(chatbotId: string): void {
    this.afs.collection('chatMessages').doc(chatbotId).delete();
  }

  public updateChatRoom(id: string, feedback: string): Observable<any> {
    return from(
      this.afs.collection('chatMessages').doc(id).update({
        updatedAt: Date.now(),
        feedback: feedback,
      })
    );
  }
}
